///ts:ref=Mob
/// <reference path="./data/game/Mob.ts"/> ///ts:ref:generated
abstract class Building extends Mob {
	static textStyle = new PIXI.TextStyle({
		fontFamily: 'courier',
		fontStyle: 'bold',
		fontSize: '16px',
		fill: 0xFFFFFF,
		stroke: 0,
		strokeThickness: 4,
	});

	public lastShot: number = -1;
	public shots: Array<Shot> = [];
	public prevShotCell: Cell = null;

	hpBar = new ProgressBar();
	level = new PIXI.Text();

	public constructor(dict: MobDict) {
		super(dict);

		this.addChild(this.hpBar);
		this.hpBar.view = new PIXI.display.View(this.hpBar);
		this.hpBar.view.parentLayer = Game.uiLayer;
		this.hpBar.position.set(0, -50);

		this.level = new PIXI.Text("" + dict.level, Building.textStyle);
		this.hpBar.addChild(this.level);
	}

	abstract updateShots(delta: number): void;

	updateAnim(delta: number) {
		centerFrickingSprite(this.level);
		this.hpBar.setProgress(this.health / this.healthMax);
	}
}
